var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReadingLevelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "summarizer-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.81 21.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.81,5.35h0c-2.42.65-4.69,2.93-5.35,5.35h0c-.65-2.42-2.93-4.69-5.35-5.35h0c2.42-.65,4.69-2.93,5.35-5.35h0c.65,2.42,2.93,4.69,5.35,5.35ZM8.35,14.54h2.41v-5.13h0c0-.33.07-.56.21-.69.23-.22.69-.25.89-.25h.46c-.78-.71-1.63-1.34-2.52-1.86-.07.04-.14.08-.21.13-.46-.41-1.08-.68-1.88-.68H0v14.97h6.2v-2.4h-3.8v-10.17h5.31c.49,0,.61.64.64.9h0v5.17ZM17.2,13.02v5.55h-5.65c-.74,0-1.39.26-1.88.76-.89.91-.91,2.24-.91,2.49l2.4-.03s.01-.82.38-.82h8.05v-11.49c-.98,1.07-1.8,2.28-2.4,3.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadingLevelIcon);
export default __webpack_public_path__ + "static/media/reading-level-icon.005d4fe80b4001975e24510862cce8d4.svg";
export { ForwardRef as ReactComponent };